var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("card-info-component", {
        attrs: {
          title: _vm.$t("pages.permission.vacations.approved"),
          value: _vm.value,
          isLoading: _vm.isLoading,
        },
        on: _vm._d({}, [_vm.valueClickedEvent, _vm.valueClicked]),
        scopedSlots: _vm._u([
          {
            key: "value",
            fn: function (props) {
              return [
                _c(
                  "a",
                  {
                    staticClass: "card-text",
                    attrs: {
                      href: "#",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false",
                    },
                  },
                  [_vm._v(" " + _vm._s(props.value) + " ")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-menu",
                    attrs: { "aria-labelledby": "dropdownMenuLink" },
                  },
                  _vm._l(_vm.items, function (item) {
                    return _c(
                      "div",
                      { key: item.id, staticClass: "dropdown-item media h-25" },
                      [
                        _c("div", { staticClass: "media-body p-1" }, [
                          _c("div", { staticClass: "text-sm p-1" }, [
                            _c("i", {
                              staticClass: "far fa-clock notification-icon",
                            }),
                            _c(
                              "span",
                              { staticClass: "pl-2" },
                              [
                                _c("formatted-date-component", {
                                  attrs: {
                                    val: item.dateStart,
                                    withTime: true,
                                  },
                                }),
                                _vm._v(" - "),
                                _c("formatted-date-component", {
                                  attrs: { val: item.dateEnd, withTime: true },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }